<script>
import Swal from 'sweetalert2';
export default {
    props: ['alert'],
    mounted() {
        const a = JSON.parse(this.alert);
        Swal.fire({
            title: a.title,
            text: a.text,
            icon: a.icon,
            timer: a.timer,
            showConfirmButton: false,
            theme: 'dark',
        });
    }
}
</script>
